import React from "react";
import { Row, Col, Button, Card, ProgressBar } from "react-bootstrap";
import * as Assets from "../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import { priceDecimal } from "../../utils/utilities";
import { useNavigate } from "react-router-dom";
import StarLeaderboard from "./star_leaderboard";
import ApiUtils from "../../utils/api_utils";

const ActivitiesContent = (p) => {
  const { dataActivities, navigate } = p;

  return (
    <Col xs={6} sm={6} md={6}>
      <Card
        className="activities-content"
        onClick={() => {
          navigate(PageRoutes.starHistory + "/redeemed");
        }}
      >
        <Row>
          <Col xs={9} sm={9} md={9}>
            {dataActivities.name}
          </Col>
          <Col xs={3} sm={3} md={3}>
            <img
              src={ApiUtils.validateImgUrl({ url: dataActivities.icon })}
              className="activities-img"
              alt="activities_image"
            />
          </Col>
        </Row>
        <Row>
          <Col className="activities-lbl">
            {priceDecimal(dataActivities.value)}
          </Col>
        </Row>
        <Row>
          <Col className="activities-lbl-detail">
            {priceDecimal(dataActivities.points)} Pts
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

const StarSummary = (props) => {
  const navigate = useNavigate();
  const { starSummaryData } = props;
  const activitiesData =
    starSummaryData.star_categories.length > 0
      ? starSummaryData.star_categories
      : [];

  return (
    <div className="home-star-content">
      <Row className="home-star">
        <Col className="current-level">
          <Row>
            <Col xs={4} sm={4} md={4}>
              <img
                src={ApiUtils.validateImgUrl({
                  url: starSummaryData.current_tier.img,
                })}
                alt="level_image"
                className="level-img"
              />
            </Col>
            <Col xs={8} sm={8} md={8}>
              <div>Current Level</div>
              <div className="level-lbl">
                {starSummaryData.current_tier.tier_name}
              </div>
            </Col>
          </Row>
        </Col>
        <Col className="current-star">
          <div>Current Stars</div>
          <Row className="star-lbl">
            <Col xs={2} sm={2} md={2}>
              <img
                src={Assets.iconStar}
                alt="star_image"
                className="star-img"
              />
            </Col>
            <Col xs={10} sm={10} md={10}>
              {priceDecimal(starSummaryData.total_stars)}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="detail-status">
        <Col xs={6} sm={6} md={6} className="header-level-lbl">
          Level
        </Col>
        <Col xs={6} sm={6} md={6} className="header-star-lbl">
          <div className="mx-3">
            <span className="mr-xs">Level and Star Info</span>
            <span
              className="badge-info"
              onClick={() => {
                navigate("/summary-info/star");
              }}
            >
              ?
            </span>
          </div>
        </Col>
      </Row>
      <div className="info-status">
        <Row>
          <Col xs={6} sm={6} md={6} className="current-status">
            <div>Current Level</div>
            <Row>
              <Col xs={3} sm={3} md={3} className="image-current-status">
                <img
                  src={ApiUtils.validateImgUrl({
                    url: starSummaryData.current_tier.img,
                  })}
                  className="current-badge-img"
                  alt="current_badge_image"
                />
              </Col>
              <Col xs={9} sm={9} md={9}>
                <Row>
                  <div>{starSummaryData.current_tier.tier_name}</div>
                  <div>{starSummaryData.current_tier.multiply} x Points</div>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col xs={6} sm={6} md={6} className="next-status">
            <div>Next Level</div>
            <Row>
              <Col xs={9} sm={9} md={9}>
                <Row className="next-status">
                  <div>{starSummaryData.next_tier.tier_name}</div>
                  <div>{starSummaryData.next_tier.multiply} x Points</div>
                </Row>
              </Col>
              <Col xs={3} sm={3} md={3} className="image-next-status">
                <img
                  src={ApiUtils.validateImgUrl({
                    url: starSummaryData.next_tier.img,
                  })}
                  className="next-badge-img"
                  alt="next_badge_image"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <ProgressBar
        variant="danger"
        now={
          (starSummaryData.total_stars / starSummaryData.stars_to_next_tier) *
          100
        }
      />
      <div className="detail-next-status">
        <div className="info">
          {priceDecimal(starSummaryData.stars_to_next_tier)} more stars to
          unlock {starSummaryData.next_tier.tier_name} level
        </div>
      </div>
      <Row className="home-button-star">
        <Button
          variant="danger"
          className="btn-star"
          onClick={() => {
            navigate(PageRoutes.reward + "/discount");
          }}
        >
          <Row>
            <Col xs={2} sm={2} md={2}>
              <img src={Assets.iconRewardWhite} alt="card_item_image" />
            </Col>
            <Col xs={8} sm={8} md={8}>
              Discount Rewards
            </Col>
          </Row>
        </Button>
        <Button
          variant="outline-danger"
          className="btn-star-outline border-0"
          onClick={() => {
            navigate(PageRoutes.starHistory);
          }}
        >
          Your Star History
        </Button>
      </Row>
      <div className="activities-star">
        <div className="activities-header">Activities</div>
        <Row>
          {activitiesData.map((data, index) => (
            <ActivitiesContent
              key={index}
              dataActivities={data}
              navigate={navigate}
            />
          ))}
        </Row>
      </div>
      <StarLeaderboard />
    </div>
  );
};

export default StarSummary;
